/**
 * How a shopper's sounds read on their cart, checkout and order — the words
 * the connector stores as the line's "Zvuk" rows.
 */

/**
 * A YouTube sound as a customer reads it: the song's name (and artist, when
 * the title does not already say it), never its link.
 */
export function youtubeName(audio: { title?: string; artist?: string; url?: string }): string {
  const title = (audio.title ?? '').trim();
  const usable = title && !/^https?:\/\//i.test(title) ? title.replace(/\s+—\s+(refren|cela pesma)$/i, '') : '';
  if (!usable) return 'YouTube pesma';
  const artist = (audio.artist ?? '').trim();
  const named = artist && !usable.toLowerCase().includes(artist.toLowerCase()) ? `${usable} — ${artist}` : usable;
  return `YouTube: ${named}`;
}
